<template>
	<modal
		class="integration-modal"
		:size="'medium'"
		v-if="show"
		@close="close">
		<div slot="header">
			<h3 v-if="formType === 'add'">Add New Warehouse</h3>
			<h3 v-else-if="formType === 'edit'">Edit Warehouse</h3>
		</div>
		<div slot="body" class="row">
			<div class="col-md-12">
				<div class="container px-0">
					<div class="row">
						<!-- address -->
						<div class="form-group col-md-12 col-sm-12 col-12">
							<label>
								<b>Label</b>
							</label>
							<input
								name="label"
								v-model="label"
								type="text"
								class="form-control"
								:class="{ 'form-error': !isLabelValid }"
								placeholder="label">
							<span class="small is-error" v-if="!isLabelValid">Label required</span>
						</div>

						<div class="form-group col-md-12 col-sm-12 col-12">
							<label>
								<b>PIC Name</b>
							</label>
							<input
								name="picName"
								v-model="picName"
								type="text"
								class="form-control"
								:class="{ 'form-error': !isPICNameValid }"
								placeholder="PIC Name">
							<span class="small is-error" v-if="!isPICNameValid">PIC Name required</span>
						</div>

						<!-- Province -->
						<div class="form-group col-sm-6 col-12">
							<label><b>Province</b></label>
							<multiselect
								name="province"
								placeholder="Province"
								label="province_name"
								track-by="province_id"
								v-model="province"
								:options="provinces"
								:show-labels="false"
								:allow-empty="false"
								:loading="isFetchingProvinces"
								:class="{ 'form-error': !isProvinceValid }"
								@select="onProvinceChange">
							</multiselect>
							<span class="small is-error" v-if="!isProvinceValid">Province required</span>
						</div>

						<!-- City -->
						<div class="form-group col-sm-6 col-12">
							<label><b>City</b></label>
							<multiselect
								name="city"
								placeholder="City"
								label="city_name_with_type"
								track-by="city_id"
								v-model="city"
								:options="cities"
								:show-labels="false"
								:allow-empty="false"
								:loading="isFetchingCities"
								:disabled="cities.length === 0"
								:class="{ 'form-error': !isCityValid }"
								@select="onCityChange">
							</multiselect>
							<span class="small is-error" v-if="!isCityValid">City required</span>
						</div>

						<!-- Sub District -->
						<div class="form-group col-sm-6 col-12">
							<label><b>Subdistrict</b></label>
							<multiselect
								name="subdistrict"
								placeholder="Subdistrict"
								label="subdistrict_name"
								track-by="subdistrict_id"
								v-model="subdistrict"
								:options="subdistricts"
								:show-labels="false"
								:allow-empty="false"
								:loading="isFetchingSubdistricts"
								:disabled="subdistricts.length === 0"
								:class="{ 'form-error': !isSubdistrictValid }"
								@select="onSubdistrictChange">
							</multiselect>
							<span class="small is-error" v-if="!isSubdistrictValid">Subdistrict required</span>
						</div>

						<!-- zip code -->
						<div class="form-group col-sm-6 col-12">
							<label><b>Zip Code</b></label>
							<input
								name="warehouseAddress"
								class="form-control"
								:disabled="true"
								v-model="zip"
								placeholder="Zip code"/>
						</div>

						<!-- Phone -->
						<div class="form-group col-sm-6 col-12">
							<label class="font-weight-bold">Phone Number</label>
							<input type="text" class="form-control" v-model="phonePrimary" :class="{ 'form-error': !isPhonePrimaryValid }">
							<span class="small is-error" v-if="!isPhonePrimaryValid">Primary phone required</span>
						</div>

						<!-- Phone Alternative -->
						<div class="form-group col-sm-6">
							<label class="font-weight-bold">Secondary Phone Number</label>
							<input type="text" class="form-control" v-model="phoneSecondary" :class="{ 'form-error': !isPhoneSecondaryValid }">
							<span class="small is-error" v-if="!isPhoneSecondaryValid">Seondary phone required</span>
						</div>

						<!-- address -->
						<div class="form-group col-md-12 col-sm-12 col-12">
							<label><b>Address</b></label>
							<textarea
								name="warehouseAddress"
								class="form-control"
								rows="5"
								v-model="address"
								:class="{ 'form-error': !isAddressValid }"
								placeholder="Address"/>
							<span class="small is-error" v-if="!isAddressValid">Address required</span>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div slot="footer">
			<button class="btn btn-light" @click="close">{{ $t('Close') }}</button>
			<button class="btn btn-primary" type="submit" @click="submit">Submit</button>
		</div>
	</modal>
</template>

<script>
import { mapGetters } from 'vuex';
import Modal from '@/components/Modal.vue';
import { duplicateVar } from '@/lib/helper';
import shippingApi from '@/api/shipping';
import warehouseApi from '@/api/warehouse';

export default {
	props: {
		show: {
			type: Boolean,
			default: false,
		},
		formType: {
			type: String,
			default: 'add',
		},
		selectedWarehouse: {
			type: Object,
			default: null,
		},
	},
	components: {
		Modal,
	},
	data() {
		return {
			isLoading: false,
			id: '',
			label: '',
			picName: '',
			subdistrict: null,
			city: null,
			province: null,
			address: '',
			defaultSelected: false,
			zip: '',
			phonePrimary: '',
			phoneSecondary: '',

			isFetchingProvinces: false,
			isFetchingCities: false,
			isFetchingSubdistricts: false,
			provinces: [],
			cities: [],
			subdistricts: [],

			isLabelValid: true,
			isPICNameValid: true,
			isProvinceValid: true,
			isCityValid: true,
			isSubdistrictValid: true,
			isAddressValid: true,
			isPhonePrimaryValid: true,
			isPhoneSecondaryValid: true,
		};
	},
	computed: {
		...mapGetters({
			user: 'user',
		}),
	},
	methods: {

		init() {
			this.clearfields();
			this.fetchDataProvince();
			if (this.formType === 'edit' && this.selectedWarehouse !== null) {
				const warehouse = duplicateVar(this.selectedWarehouse);
				this.id = warehouse._id;
				this.label = warehouse.label;
				this.picName = warehouse.pic_name;
				this.province = {
					province_id: warehouse.province.id,
					province_name: warehouse.province.name,
				};
				this.city = {
					city_id: warehouse.city.id,
					city_name_with_type: warehouse.city.name,
				};
				this.subdistrict = {
					subdistrict_id: warehouse.subdistrict.id,
					subdistrict_name: warehouse.subdistrict.name,
				};
				this.address = warehouse.address;
				this.zip = warehouse.zip ? warehouse.zip : '';
				this.phonePrimary = warehouse.phone_primary ? warehouse.phone_primary : '';
				this.phoneSecondary = warehouse.phone_secondary ? warehouse.phone_secondary : '';
				this.defaultSelected = warehouse.default;
			}
		},

		// fetch province data
		fetchDataProvince() {
			if (this.provinces.length === 0) this.fetchProvinces();
		},

		fetchProvinces() {
			this.isFetchingProvinces = true;
			const callback = (response) => {
				this.provinces = response.data;
				this.isFetchingProvinces = false;
			};
			const errorCallback = (e) => {
				// eslint-disable-next-line
				console.log(e);
				this.isFetchingProvinces = false;
			};
			shippingApi.getAllProvinces(callback, errorCallback);
		},

		fetchCities(provinceId) {
			this.isFetchingCities = true;
			const params = {
				province_id: provinceId,
			};
			const callback = (response) => {
				this.isFetchingCities = false;
				this.cities = response.data;
			};
			const errorCallback = (e) => {
				this.isFetchingCities = false;
				// eslint-disable-next-line
				console.log(e);
			};
			shippingApi.getCities(params, callback, errorCallback);
		},

		fetchSubdistricts(cityId) {
			this.isFetchingSubdistricts = true;
			const callback = (response) => {
				this.subdistricts = response.data;
				this.isFetchingSubdistricts = false;
			};
			const errorCallback = () => {
				this.isFetchingSubdistricts = false;
			};
			shippingApi.getSubdistricts(cityId, callback, errorCallback);
		},

		// set province on init
		setProvince() {
			if (this.province) {
				const provinceName = this.province.province_name;
				const province = this.provinces.find(province => province.province_name === provinceName);
				if (province) {
					this.province = province;
				}
			}
		},

		// set city on init
		setCity() {
			if (this.city) {
				const cityName = this.city.city_name_with_type;
				const city = this.cities.find(city => city.city_name_with_type === cityName);
				if (city) {
					this.city = city;
				}
			}
		},

		// set subdisc on init
		setSubdistrict() {
			if (this.subdistrict) {
				const subdistrictName = this.subdistrict.subdistrict_name;
				const subdistrict = this.subdistricts.find(subdistrict => subdistrict.subdistrict_name === subdistrictName);
				if (subdistrict) {
					this.subdistrict = subdistrict;
				}
			}
		},

		// onchange province select
		onProvinceChange(province) {
			this.city = null;
			this.subdistrict = null;
			this.province = province;
		},

		// onchange city
		onCityChange(city) {
			this.subdistrict = null;
			this.city = city;
		},

		// onchange district
		onSubdistrictChange(subDisc) {
			this.subdistrict = subDisc;
			this.zip = subDisc.zip && subDisc.zip !== '' ? subDisc.zip : '';
		},

		submit() {
			const valid = this.validate();
			if (valid) {
				if (this.formType === 'add') {
					this.doSubmit();
				} else {
					this.doUpdate();
				}
			}
		},

		validate() {
			let valid = true;

			// label
			if (this.label === '') {
				valid = false;
				this.isLabelValid = false;
			} else {
				valid = true;
				this.isLabelValid = true;
			}

			// PIC Name
			if (this.picName === '') {
				valid = false;
				this.isPICNameValid = false;
			} else {
				valid = true;
				this.isPICNameValid = true;
			}

			// province
			if (this.province === null) {
				valid = false;
				this.isProvinceValid = false;
			} else {
				valid = true;
				this.isProvinceValid = true;
			}

			// city
			if (this.city === null) {
				valid = false;
				this.isCityValid = false;
			} else {
				valid = true;
				this.isCityValid = true;
			}

			// subdistrict
			if (this.subdistrict === null) {
				valid = false;
				this.isSubdistrictValid = false;
			} else {
				valid = true;
				this.isSubdistrictValid = true;
			}

			// address
			if (this.address === '') {
				valid = false;
				this.isAddressValid = false;
			} else {
				valid = true;
				this.isAddressValid = true;
			}

			// phone primary
			if (this.phonePrimary === '') {
				valid = false;
				this.isPhonePrimaryValid = false;
			} else {
				valid = true;
				this.isPhonePrimaryValid = true;
			}

			// phone secondary
			if (this.phoneSecondary === '') {
				valid = false;
				this.isPhoneSecondaryValid = false;
			} else {
				valid = true;
				this.isPhoneSecondaryValid = true;
			}

			return valid;
		},

		getParams() {
			const province = {
				id: this.province.province_id,
				name: this.province.province_name,
			};
			const city = {
				id: this.city.city_id,
				name: this.city.city_name_with_type,
			};
			const subdistrict = {
				id: this.subdistrict.subdistrict_id,
				name: this.subdistrict.subdistrict_name,
			};
			const address = this.address.replace(/[^a-zA-Z0-9,. ]/g, '');

			const params = {
				label: this.label,
				pic_name: this.picName,
				province: JSON.stringify(province),
				city: JSON.stringify(city),
				subdistrict: JSON.stringify(subdistrict),
				address,
				phone_primary: this.phonePrimary,
				phone_secondary: this.phoneSecondary,
				zip: this.zip,
				default: this.defaultSelected, // boolean
			};

			if (this.user.role === 'admin' || this.user.role === 'superadmin') {
				params.created_by_admin = true;
			}

			return params;
		},

		doSubmit() {
			const params = this.getParams();

			const callback = (response) => {
				const warehouse = response.data;
				this.$emit('set', warehouse);
				this.clearfields();
				this.close();
			};
			const errorCallback = (err) => {
				console.log('errorCallback -> err', err);
			};
			warehouseApi.store(params, callback, errorCallback);
		},

		doUpdate() {
			const id = this.id;
			const params = this.getParams();
			const callback = (response) => {
				const warehouse = response.data;
				this.$emit('set', warehouse);
				this.clearfields();
				this.close();
			};
			const errorCallback = (err) => {
				console.log('errorCallback -> err', err);
			};
			warehouseApi.update(id, params, callback, errorCallback);
		},

		close() {
			this.$emit('close');
		},

		clearfields() {
			this.id = '';
			this.label = '';
			this.picName = '';
			this.address = '';
			this.province = null;
			this.city = null;
			this.subdistrict = null;
			this.defaultSelected = false;
			this.zip = '';
			this.phonePrimary = '';
			this.phoneSecondary = '';
		},
	},
	watch: {
		show(show) {
			if (show) {
				this.init();
			}
		},
		province(province) {
			if (province) {
				this.isProvinceValid = true;
				this.fetchCities(province.province_id);
			}
		},
		cities() {
			this.setCity();
		},
		city(city) {
			if (city && city !== null) {
				this.isCityValid = true;
				this.fetchSubdistricts(city.city_id);
			}
		},
		subdistrict(subdistrict) {
			if (subdistrict && subdistrict !== null) {
				this.isSubdistrictValid = true;
				this.setSubdistrict();
			}
		},
		label(label) {
			if (label) {
				this.isLabelValid = true;
			}
		},
		picName(picName) {
			if (picName) {
				this.isPICNameValid = true;
			}
		},
		address(address) {
			if (address) {
				this.isAddressValid = true;
			}
		},
		phonePrimary(phonePrimary) {
			if (phonePrimary) {
				this.isPhonePrimaryValid = true;
			}
		},
		phoneSecondary(phoneSecondary) {
			if (phoneSecondary) {
				this.isPhoneSecondaryValid = true;
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.is-error {
	color: red;
}

.form-error {
	border-color: red;
}
</style>
